import { render, staticRenderFns } from "./BackOffice.vue?vue&type=template&id=6886deda&scoped=true&"
import script from "./BackOffice.vue?vue&type=script&lang=ts&"
export * from "./BackOffice.vue?vue&type=script&lang=ts&"
import style0 from "./BackOffice.vue?vue&type=style&index=0&id=6886deda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6886deda",
  null
  
)

export default component.exports